import { Model } from 'infra/model'
import { observable, makeObservable, computed } from 'mobx'
import { DateZero, maybeParseDate } from 'utils/date-util'
import { Id } from 'types/definitions'
import {
  BillingTransactionDTO,
  BillingTransactionType,
  IBillingTransactionMetadata,
} from 'billing/dtos/billing-transaction'

export default class BillingTransaction extends Model<
  BillingTransactionDTO,
  BillingTransaction
> {
  id = Id.none

  @observable amount = 0
  @observable billingMethodId = Id.none
  @observable payoutMethodId = Id.none
  @observable dateCreated = DateZero()
  @observable transactionType: BillingTransactionType = 'PURCHASE'
  @observable refund_target_transaction = ''
  @observable version = 0
  metadata: IBillingTransactionMetadata = { receipt_url: null }

  constructor() {
    super()
    makeObservable(this)
  }

  @computed
  get isPurchase() {
    return this.transactionType === 'PURCHASE'
  }

  @computed
  get isRefund() {
    return this.transactionType === 'REFUND'
  }

  parse(json: Partial<BillingTransactionDTO>): Partial<BillingTransaction> {
    return {
      id: json.id,
      amount: json.amount,
      billingMethodId: json.billing_method_id,
      payoutMethodId: json.payout_method_id,
      dateCreated: maybeParseDate(json.date_created),
      transactionType: json.transaction_type,
      refund_target_transaction: json.refund_target_transaction,
      version: json.version,
      metadata: json.metadata,
    }
  }
}
